export default "__VITE_ASSET__CLmFoRmE__"